<template>
    <div class='category'>

        <div class="tile is-parent">
            <article class="tile is-child box">
                <table class="table is-bordered">
                    <thead>
                    <tr>
                        <th v-for='item in list'>
                            <div class="font"><span>价格范围</span><span style="margin-right: 10px;margin-left: 10px">|</span><span>{{item.definedCategoryInfo}}</span></div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for='item in formatList'>
                        <td v-for='value in item'>
                            <div v-if="value">
                                <input type="number" v-model.number="value.startPrice" style="width: 50px" @change='doSave(value)'/>
                                <span>-</span>
                                <input type="number" v-model.number="value.endPrice" style="width: 50px" @change='doSave(value)'/>
                                <span style="margin-right: 10px;margin-left: 10px">|</span>
                                <span>{{value.name}}</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </article>
        </div>
        <div class='button-wrap'>
            <el-button @click='back'>返回</el-button>
        </div>
    </div>
</template>

<script type="text/babel">
    export default {
        data() {
            return {
                list: [],
                formatList: [],
                a:123,
            }
        },
        mounted() {
            this.getList()
            this.format()
        },
        methods: {
            getList() {
                HttpRequest.get('/admin.php?method=aicategoryinfo.getAiCategoryList').then(response => {
                    this.list = response.data.list ? response.data.list: this.list
                    this.format()
                })
            },
            format() {
                let maxLength = 0
                let listLength = this.list.length
                let temList = []
                this.list.forEach((item, index) => {
                    if (maxLength < item.originNameList.length) {
                        maxLength = item.originNameList.length
                    }
                })
                let index = 0
                while(index < maxLength) {
                    temList[index] = []
                    this.list.forEach((value, key) => {
                        temList[index].push(value.originNameList[index])
                    })
                    ++index
                }
                this.formatList = temList
            },
            doSave(item){
                let params={
                    name:item.name,
                    startPrice:item.startPrice,
                    endPrice:item.endPrice,
                }
                console.log(params)
                HttpRequest.get('/admin.php?method=aicategoryinfo.doSavePrice',params).then(response => {
                    if(response.data.success){
                            this.$message("保存成功")
                    }
                })
            },
            back(){
                this.$router.push({
                    name: 'similaryGoods',
                })
            },


        }
    }
</script>
<style lang="less" scoped>
 .font{
     font-weight: bold;
     color: #333;
 }
</style>